import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import refundSettingsReducer from '../reducers/refundSettingsReducer';

const configureStore = (railsProps) => (
  createStore(refundSettingsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
